import { createContext, useContext } from 'react';
import type { ClientPrincipal, Role } from '@mas-flow/types';

export type AuthStatus = 'loading' | 'signed-in' | 'anonymous' | 'error';

export interface AuthState {
  status: AuthStatus;
  user: ClientPrincipal | null;
  roles: Role[];
}

export const AuthContext = createContext<AuthState | undefined>(undefined);

export function useAuth(): AuthState {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside <AuthProvider>');
  return ctx;
}

const SYSTEM_ROLES = new Set(['anonymous', 'authenticated']);

export function filterCustomRoles(all: ReadonlyArray<string>): Role[] {
  return all.filter((r): r is Role => !SYSTEM_ROLES.has(r) && isAppRole(r));
}

function isAppRole(r: string): r is Role {
  return r === 'admin' || r === 'leader' || r === 'scorer' || r === 'viewer';
}
